import React from 'react';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import { Inner, gridColumns } from 'styles/structure';
import { Link } from 'gatsby';
import colors from 'styles/colors';

const GridPeopleContainer = styled.div`
  &:last-child {
    margin-bottom: 8rem;
  }
 
  & + * {
    margin-top: 6.4rem;
  }
  
  header {
    text-align: center;
    
    & + * {
      margin-top: 2.4rem;
    }
  }
  
  @media (min-width: ${dimensions.tabletPortraitUp}px) {
    header {
      text-align: left;
    }
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    &:last-child {
      margin-bottom: 10.4rem;
    }
    
    & + * {
      margin-top: 10.4rem;
    }
    
    header {      
      & + * {
        margin-top: 6.4rem;
      }
    }
  }
`;

const GridPeopleItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  li {
    list-style: none;
    width: 100%;
    max-width: 40rem;
    
    & + * {
      margin-top: 4rem;
    }
  }

  img {
    display: block;
    width: 100%;
    max-width: 40rem;
  }

  span {
    font-size: 1.8rem;
  }

  h5 {
    font-weight: 500;
  }

  @media (min-width: ${dimensions.tabletPortraitUp}px) and (max-width: ${dimensions.tabletLandscapeUp}px) {
    flex-direction: row;
    flex-wrap: wrap;

    li {
      ${gridColumns('1/2', 6.4)}
      margin-top: 0rem;
    }
    li:nth-of-type(n + 3) {
      margin-top: 4.8rem;
    }

    p {
      max-width: 90%;
    }
  }

  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    flex-direction: row;
    flex-wrap: wrap;

    li {
      ${gridColumns('1/3', 6.4)}
      margin-top: 0rem;
      margin-right: 3.2rem;

      &:nth-of-type(3n) {
        margin-right: 0;
      }
      &:nth-of-type(n + 4) {
        margin-top: 4.8rem;
      }
    }

    p {
      max-width: 90%;
    }
  }

  @media (min-width: ${dimensions.desktopUp}px) {
    img {
      max-width: 100%;
    }
  }
`;

const Person = styled(Link)`
  h5, span {
    color: ${colors.teal800};
    transition: color 0.12s ease-in-out;
  }
  
  
  &:hover {
    h5, span {
      color: ${colors.red500};
    }
  }
`;

const PersonImage = styled.div`
  position: relative;
  max-width: 40rem;
  padding-bottom: 100%;
  overflow: hidden;
  
  img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PersonContent = styled.div`
  margin-top: 1.6rem;
`;

const GridPeople = ({ heading, people, anchor }) => {
  return (
    <GridPeopleContainer id={anchor}>
      <Inner>
        <header>
          <h2>{heading}</h2>
        </header>

        <GridPeopleItems>
          {people.map((person, i) => (
            <li key={i}>
              {person.member && (
                <Person to={`/bio/${person.member._meta.uid}`}>
                  {person.member.image && (
                    <PersonImage>
                      <img
                        src={person.member.image.url}
                        alt={person.member.image.alt}
                        loading="lazy"
                      />
                    </PersonImage>
                  )}

                  <PersonContent>
                    <h5 className="is-small">{person.member.name}</h5>
                    <span>{person.member.title}</span>
                  </PersonContent>
                </Person>
              )}
            </li>
          ))}
        </GridPeopleItems>
      </Inner>
    </GridPeopleContainer>
  );
};

export default GridPeople;
